import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ChartComponent from "../Highcharts/ChartComponent";
import {
  trendSplineConfig,
  reportBarConfig,
  horizontalBarGraph,
  pieChartConfig,
} from "../Highcharts/chartConfig";
import { ChartLoader } from "../components/ShimmerLoader";
import { useSelector } from "react-redux";
import Map from "./Map";
import { colorPalettes } from "../data/common";
import {
  getMonthWiseOnboardedUsersCount,
  getSurveyResponseCountsForDiagnosedUsers,
  surveyCountForOpenDashboard,
} from "../services/urls";
import API from "../services/apiMiddleware";

function Charts({ isPayload, chartNames }) {
  const [onboardingChart, setOnboardingChart] = useState({});
  const [surveyDistributionChart, setSurveyDistributionChart] = useState({});
  const [disaggregationDistrictChart, setDisaggregationDistrictChart] =
    useState({});
  const [diagnosedUsers, setDiagnosedUsers] = useState([]);

  const [districtKey, setDistrictKey] = useState("percent");
  const [numPercentKey, setNumPercentKey] = useState("percent");
  const categoryList = useSelector((state) => state.surveyCategoryLists);
  const communityId = useSelector((state) => state.communityData.communityId);

  useEffect(() => {
    fetchTrendChartData();
  }, []);

  useEffect(() => {
    if (
      categoryList &&
      categoryList.length > 0 &&
      Object.keys(isPayload).length > 0
    ) {
      fetchDistributionOfDiagnosed();
    }
  }, [categoryList, isPayload]);

  useEffect(() => {
    if (Object.keys(isPayload).length > 0) {
      fetchPieChartData();
    }
  }, [isPayload]);

  const fetchTrendChartData = async () => {
    const oRequest = {
      communityId,
    };
    API.post(getMonthWiseOnboardedUsersCount, oRequest)
      .then(({ data }) => {
        let trendLineChartData = data.data;
        if (Object.keys(trendLineChartData).length > 0) {
          let catagoriesArr = Object.keys(trendLineChartData);
          let chartValues = Object.values(trendLineChartData);
          let lineChartObj = {
            catagoriesArr,
            chartValues,
          };
          setOnboardingChart(lineChartObj);
        }
      })
      .catch((error) => {
        console.error("Error fetching month wise count data:", error);
      });
  };

  const fetchDistributionOfDiagnosed = async () => {
    const surveyId = Number(categoryList[0]?.categoryId);
    const oRequest = { ...isPayload, surveyId };
    API.post(surveyCountForOpenDashboard, oRequest)
      .then(({ data }) => {
        const diagnosedCondition = data.data;

        const categoryArr = Object.keys(diagnosedCondition[1].optionCounts);
        const chartValues = Object.values(diagnosedCondition[1].optionCounts);

        const total = chartValues.reduce((a, b) => a + b, 0);

        const percentageCount = chartValues.map((count) => {
          const percentage = Math.round((count / total) * 100);
          return percentage ? percentage : 0;
        });
        const obj = {
          categoryArr,
          chartValues,
          percentageCount,
        };

        setSurveyDistributionChart(obj);

        const diagnosedConditionArr = Object.keys(
          diagnosedCondition[0].optionCounts
        );
        const diagnosedConditionVal = Object.values(
          diagnosedCondition[0].optionCounts
        );

        const diadnosedTotal = diagnosedConditionVal.reduce((a, b) => a + b, 0);

        const diadnosedPercentageCount = diagnosedConditionVal.map((count) => {
          const percentage = Math.round((count / diadnosedTotal) * 100);
          return percentage ? percentage : 0;
        });

        const diagnosedConditionValue = [
          {
            data: diagnosedConditionVal,
            color: "#7030a0",
          },
        ];
        const diagnosedConditionPercent = [
          {
            data: diadnosedPercentageCount,
            color: "#7030a0",
          },
        ];

        const diagnosedConditionObj = {
          diagnosedConditionArr,
          diagnosedConditionValue,
          diagnosedConditionPercent,
        };
        setDisaggregationDistrictChart(diagnosedConditionObj);
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      });
  };

  const fetchPieChartData = () => {
    API.post(getSurveyResponseCountsForDiagnosedUsers, isPayload)
      .then(({ data }) => {
        let pieChartData = data.data;
        if (pieChartData && Object.keys(pieChartData).length > 0) {
          let catagoriesArr = Object.keys(pieChartData);
          let seriesArray = [];
          catagoriesArr.forEach((item, index) => {
            seriesArray = [
              ...seriesArray,
              {
                name: item,
                y: pieChartData[item],
                color: colorPalettes[index],
              },
            ];
          });
          setDiagnosedUsers(seriesArray);
        }
      })
      .catch((error) => {
        console.error("Error fetching for diagnosed users  data:", error);
      });
  };

  return (
    <div className="main-OverviewSection">
      <Grid container spacing={2} className="formscardsection">
        <Grid size={{ xs: 12, lg: 4 }}>
          <Card className="formcard">
            <CardContent className="formcardcontent">
              <div className="cardheader">
                <Typography>{chartNames.chartOne}</Typography>
              </div>
              {Object.keys(onboardingChart).length > 0 ? (
                <>
                  <div
                    className="col-12 percent-number-button"
                    style={{ height: "26px" }}
                  ></div>
                  <ChartComponent
                    options={trendSplineConfig(onboardingChart)}
                  />
                </>
              ) : (
                <ChartLoader style={{ height: "488px" }}></ChartLoader>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Card className="formcard">
            <CardContent className="formcardcontent">
              <div className="cardheader">
                <Typography>{chartNames.chartTwo}</Typography>
              </div>
              {Object.keys(surveyDistributionChart).length > 0 ? (
                <>
                  <div className="col-12 percent-number-button">
                    <button
                      onClick={() => {
                        setNumPercentKey("percent");
                      }}
                      className={`button ${
                        numPercentKey == "percent" ? "active" : ""
                      }`}
                    >
                      %
                    </button>
                    <button
                      href=""
                      onClick={() => {
                        setNumPercentKey("num");
                      }}
                      className={`button ${
                        numPercentKey == "num" ? "active" : ""
                      }`}
                    >
                      #
                    </button>
                  </div>
                  <ChartComponent
                    options={reportBarConfig(
                      surveyDistributionChart,
                      numPercentKey
                    )}
                  />
                </>
              ) : (
                <ChartLoader></ChartLoader>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Card className="formcard">
            <CardContent className="formcardcontent">
              <div className="cardheader">
                <Typography>{chartNames.chartThree}</Typography>
              </div>
              {Object.keys(disaggregationDistrictChart).length > 0 ? (
                <>
                  <div className="col-12 percent-number-button">
                    <button
                      onClick={() => {
                        setDistrictKey("percent");
                      }}
                      className={`button ${
                        districtKey == "percent" ? "active" : ""
                      }`}
                    >
                      %
                    </button>
                    <button
                      href=""
                      onClick={() => {
                        setDistrictKey("num");
                      }}
                      className={`button ${
                        districtKey == "num" ? "active" : ""
                      }`}
                    >
                      #
                    </button>
                  </div>
                  <ChartComponent
                    options={horizontalBarGraph(
                      disaggregationDistrictChart,
                      districtKey
                    )}
                  />
                </>
              ) : (
                <ChartLoader></ChartLoader>
              )}
            </CardContent>
          </Card>
        </Grid>
        {/* Newly added */}
        <Grid size={{ xs: 12, lg: 4 }}>
          <Card className="formcard">
            <CardContent className="formcardcontent">
              <div className="cardheader">
                <Typography>{chartNames.chartFour}</Typography>
              </div>
              <Map />
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Card className="formcard">
            <CardContent className="formcardcontent">
              <div className="cardheader">
                <Typography>{chartNames.chartFive}</Typography>
              </div>
              {diagnosedUsers.length > 0 ? (
                <ChartComponent options={pieChartConfig(diagnosedUsers)} />
              ) : (
                <ChartLoader></ChartLoader>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default Charts;
